import mySuxApi from '../services/dataSources/mySuxApi';

import { config } from '../config/';
 

/**
 * 
 * @param { string } orderIdx order Idx string
 * @param { string } userGuid user identification guid
 * 
 * @returns { Promise<Object>} promise resolving to delivery info object or a rejection if not present.
 * @example {
 *     "deliveryDate": "2018-06-02T00:00:00",
 *     "specialRequirements": "dfsgsdfgsdfgsdfgdfsgdfljihksdfsdfkuhyilgfrkljsdf",
 *     "deliveryTimeSlot": "09:30 - 13:30"
 *   }
 */
export function getDeliveryInfo(orderIdx, userGuid) {
  const url = `${config.URLS.MY_SOFOLOGY_API}${userGuid}/BookDelivery/GetDeliveryQuote/${orderIdx}`;
  return mySuxApi.get(url)
    .then((res) => {
      if(!res.data || !res.data.chosenDelivery) return Promise.reject();
      return res.data.chosenDelivery;
    });
}



// WEBPACK FOOTER //
// ./src/services/orderService.js